<button [disabled]="textService.onCreating||editorService.blockUserAction" class="btn btn-add"  (click)="createText()">
  <ng-container *ngIf="!textService.onCreating">
      Create New
      <i class="vi vi-plus"></i>
  </ng-container>
  <ng-container *ngIf="textService.onCreating">
      Creating text...
  </ng-container>
</button>